import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
    name: 'truncateSafeHtml',
    pure: true,
    standalone: false
})
export class TruncateSafeHtmlPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) { }

  transform(value: SafeHtml | null | undefined, limit = 80): SafeHtml {
    if (!value) {
      return this.sanitizer.bypassSecurityTrustHtml('');
    }

    // 🔑 Angular guarda el HTML real en esta propiedad interna
    const htmlString = (value as any).changingThisBreaksApplicationSecurity ?? '';

    if (typeof htmlString !== 'string') {
      return value;
    }

    if (htmlString.length <= limit) {
      return value;
    }

    const truncated = htmlString.slice(0, limit) + '...';

    return this.sanitizer.bypassSecurityTrustHtml(truncated);
  }
}
